import {
  MockMap,
} from '@ama-sdk/core';
import {
  createMockData,
} from '@dapi/sdk/spec';
import {
  orderWithInvolutaryRefundEligibleRoundTripDisruptedUsingCard,
} from '../../../mock/data/index';

export const notEligibleToSelfReaccMock: MockMap = {
  retrieveOrder: [createMockData(orderWithInvolutaryRefundEligibleRoundTripDisruptedUsingCard)]
};
